import { PublicClientApplication, LogLevel } from '@azure/msal-browser'

// These values are safe to be in frontend code — they identify the app
// but do not grant any permissions on their own
const ENTRA_TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID as string
const ENTRA_CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID as string

if (!ENTRA_TENANT_ID || !ENTRA_CLIENT_ID) {
  throw new Error('VITE_ENTRA_TENANT_ID and VITE_ENTRA_CLIENT_ID must be set')
}

export const msalConfig = {
  auth: {
    clientId: ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage persists tokens across browser tabs and survives page refresh,
    // which is needed for the PRISM internal tool UX. Trade-off: tokens survive
    // XSS until they expire (~1h for access tokens). PRISM is internal-only and
    // sits behind Entra SSO, so this is an accepted risk — standard MSAL pattern.
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return // Never log PII
        if (import.meta.env.DEV) {
          console.warn(`MSAL [${LogLevel[level]}]: ${message}`)
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
}

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${ENTRA_CLIENT_ID}/PRISM.Read`, // Custom scope defined in your Entra app registration
  ],
}

export const msalInstance = new PublicClientApplication(msalConfig)

// Initialise and handle redirect promise
await msalInstance.initialize()
await msalInstance.handleRedirectPromise()
